import React from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import {Block} from '../../styles/commons';
import PortalRecentMessageCenter from '../PortalRecentMessageCenter/PortalRecentMessageCenter'


const MessageScreen = props => {

  return (
    <Layout product='portal'>
      <PageHeader title='Messages' />
      <Block>
        <h2>Select a message below to access that source of funds' thread ...</h2>
        <PortalRecentMessageCenter {...props}/>
      </Block>
    </Layout>
  );
};

export default MessageScreen;
